<template>
    <div class="list">
        <!-- <div id="news" v-for="item in news" :key="item">
            <div>
                <img class="news_photo" :src="item.img"/>
            </div>
            <div class="news_right">
                <a class="title" :href="item.url" target="_blank">{{item.title}}</a>
                <div class="introduce">{{item.mess}}</div>
                <div class="info">
                    <div>发布时间：2020.1.20</div>
                    <div style="margin-left: 12px;">作者：护眼天使</div>
                    <div style="margin-left: 12px;">阅读{{item.read}}</div>
                    <div style=" margin-left: 12px;">评论{{item.comment}}</div>
                </div>
            </div>
        </div> -->
        <div id="news" v-for="item in newList" :key="item">
            <div>
                <img class="news_photo" :src="item.img"/>
            </div>
            <div class="news_right">
                <a class="title" @click="toDetail(item.cid)">{{item.title}}</a>
                <div class="introduce">{{item.abstract}}</div>
                <div class="info">
                    <div>发布时间：{{item.create_time|setTime}}</div>
                    <div style="margin-left: 12px;">作者：{{item.author}}</div>
                    <div style="margin-left: 12px;">点击量{{item.click}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "news",
        data() {
            return {
                // news:[{
                //     img:require("../assets/article1.png"),
                //     title : "验光科普：3分钟教你看懂验光单", mess: "手里拿着验光单，你是否都会非常好奇视力情况怎样？但倘若没有专业人士的解读，面对验光单中的各种符号数据，是否往往一脸懵逼。",
                //     url:"https://mp.weixin.qq.com/s?__biz=MzAwNzk1NDQ4NQ==&mid=2247483740&idx=1&sn=e47c3f663af4b1e742aa0044cb873772&chksm=9b770806ac0081105d72574b78ca177cd3adf6538142d32ab6eda5e8b64d01b6de5b1dee9952&token=66137743&lang=zh_CN#rd"
                //     ,time:"2020.7.20",read:"1365",comment:"135"
                // },{
                //     img:require("../assets/article2.png"),
                //     title : "近视早知道：你的“远视储备”还剩多少？", mess: "我们每个人刚出生时都是远视眼，然后随着身体的成长发育，眼轴的增长，慢慢的由远视到正视，再因为各位原因导致近视的发生。",
                //     url:"https://mp.weixin.qq.com/s?__biz=MzAwNzk1NDQ4NQ==&mid=2247483740&idx=2&sn=a7c2106f373154fe4e057e611d73e56d&chksm=9b770806ac00811022d48ad11eec9d97c0e1098752e8c0798c56921aa05ebfe0084ecbf7e0e9&token=66137743&lang=zh_CN#rd"
                //     ,time:"2020.7.13",read:"1285",comment:"257"
                // },{
                //     img:require("../assets/article3.png"),title : "保护眼健康：0-3岁，要注意哪些眼病？", mess: "眼睛是我们心灵的窗口，也是人体最重要的器官之一，因为90%的外界信息通过眼睛获取...",
                //     url:"https://mp.weixin.qq.com/s?__biz=MzAwNzk1NDQ4NQ==&mid=2247483740&idx=3&sn=ad03513966f0865690aed73e1bde96d4&chksm=9b770806ac0081104ec705470248e8919c67ffaff30cff4d1116c1dc00bc8621238ad2ad4a5a&token=66137743&lang=zh_CN#rd"
                //     ,time:"2020.6.18",read:"985",comment:"366"
                // },{
                //     img:require("../assets/article4.png"),title : "保护眼健康：3-7岁，要注意哪些眼病？", mess: "眼睛是我们心灵的窗口，也是人体最重要的器官之一，因为90%的外界信息通过眼睛获取，如读书认字、看图赏画、看人物、欣赏美景等...",
                //     url:"https://mp.weixin.qq.com/s?__biz=MzAwNzk1NDQ4NQ==&mid=2247483740&idx=4&sn=7c9318333ba16cea7de8762cc5d80823&chksm=9b770806ac0081106b03214e6d6230fcc1958fe1c4c2dc038cc9108592b8c415176017673750&token=66137743&lang=zh_CN#rd"
                //     ,time:"2020.6.13",read:"425",comment:"478"
                // },{
                //     img:require("../assets/article5.png"),title : "保护眼健康：7岁以后，要警惕以下眼病", mess: "保护眼睛，保护我们接触世界的窗户，只有更好的了解常见眼病才能更好预防，保护心灵的窗口。",
                //     url:"https://mp.weixin.qq.com/s?__biz=MzAwNzk1NDQ4NQ==&mid=2247483740&idx=5&sn=17ebe0321b8b75887c1cc35771af4bca&chksm=9b770806ac008110be2891e9ef9501fef86aab015d64d8b1953314cf3dbc5dc9802394b833be&token=66137743&lang=zh_CN#rd"
                //     ,time:"2020.6.5",read:"2555",comment:"256"
                // },{
                //     img:require("../assets/article6.png"),title : "近视早知道：你的近视可能是假性近视", mess: "在日常生活中，我们偶尔会听到周边朋友在讨论，谁谁家的孩子用了几个月某品牌产品视力就恢复了，或者只是减少近距离阅读，就不再近视了；",
                //     url:"https://mp.weixin.qq.com/s?__biz=MzAwNzk1NDQ4NQ==&mid=2247483740&idx=6&sn=2bd7b2b2c6fa301feda07cc306d71d83&chksm=9b770806ac0081102c4732e59c38da018e57c68feeaa47010e879adcb553d94ffa762f392bbd&token=66137743&lang=zh_CN#rd"
                //     ,time:"2020.6.1",read:"987",comment:"317"
                // },{
                //     img:require("../assets/article7.png"),title : "眼健康科普：眼保健操真的有用吗？", mess: "“眼保健操现在开始，闭眼……” 伴随着舒缓的音乐，连同喊节拍的清脆童音，就像一个时代的印记，印刻在美好的回忆里。",
                //     url:"https://mp.weixin.qq.com/s?__biz=MzAwNzk1NDQ4NQ==&mid=2247483740&idx=7&sn=df33b12d306fbccf89ca7dcaa3ae23aa&chksm=9b770806ac008110b46544396d54bc8cfa575f6b1e4f2707594cb263b19c11e02bf52d229b9e&token=66137743&lang=zh_CN#rd"
                //     ,time:"2020.5.31",read:"1324",comment:"289"
                // }]
                newList:[]
            }
        },
        mounted(){
            axios({
                url:'/web.php/news/news_list'
            }).then(res=>{
              console.log(res.data.msg == "ok");
              if(res.data.msg == "ok"){
                this.newList = res.data.data
              }
            })
        },
        filters:{
            setTime(time) {
                let now = new Date(1000 * time);
                var year = now.getFullYear();
                var month = now.getMonth() + 1;
                if (month < 10) {
                  month = "0" + month;
                }
                var date = now.getDate();
                if (date < 10) {
                  date = "0" + date;
                }
                return year + "-" + month + "-" + date
            },
        },
        methods:{
            toDetail(cid){
                this.$router.push({
                    path: "/news/details",
                    query: {
                      cid: cid,
                    },
                });
            }
        }
    }
</script>

<style scoped>
    .list {
        width: 50%;
        margin: 0 auto;
    }

    #news {
        display: flex;
        margin-left: 20px;
        padding-top:30px;
    }

    .news_photo {
        width: 246px;
        height: 138px;
    }

    .news_right {
        -ms-text-align-last: left;
        text-align-last: left;
        margin-left: 25px;

    }

    .title {
        font-size: 22px;
        margin-top: 5px;
        display: inline-block;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color:transparent;
        outline:none;
        text-decoration: none;
        color: #333;

    }
    .title:visited{
        color: #333;
    }
    .title:hover{
        text-decoration: underline;
    }
    .introduce {
        font-size: 13px;
        color: #666;
        margin-top: 10px;
    }

    .info {
        font-size: 12px;
        color: #c1c1c1;
        display: flex;
        margin-top: 20px;
    }


    @media (max-width: 1024px) {
        .list {
            width: 100%;
            margin: 0 auto;

        }

        #news {
            margin-left: 5px;
            margin-right: 5px;
            border-bottom: 5px solid #f8f8f8    ;
            padding-top: 10px;
        }

        .news_photo {
            display: none;
        }
        .title {
            margin-top: 5px;
        }

        .introduce {
            margin-top: 5px;
        }

        .info {
            margin-top: 5px;
            margin-bottom: 10px;
        }
    }

</style>